export default __webpack_public_path__ + "static/media/001-with-trophy.9c0aa5e6.png";